import ArticlesIndex from "@/components/ArticlesIndex";

export default function Insights() {
  return <ArticlesIndex section="insights" searchable />;
}
